var _path, _path2, _path3, _line, _path4, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1795 17.7412C5.9514 17.7412 1.71289 19.295 1.71289 21.2123V25.6301C1.71289 27.5474 5.9514 29.1012 11.1795 29.1012C16.4076 29.1012 20.6461 27.5474 20.6461 25.6301V21.2123C20.6461 19.295 16.4076 17.7412 11.1795 17.7412Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7951 24.4216C13.6812 24.5901 12.46 24.6835 11.1795 24.6835C5.9514 24.6835 1.71289 23.1297 1.71289 21.2124",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6462 21.2124C20.6462 22.279 19.3347 23.2332 17.271 23.8694",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.92162,
    y1: 22.6395,
    x2: 15.0059,
    y2: 17.8835,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9283 25.0254C23.5373 24.7604 24.1009 24.3842 24.59 23.8951C26.9308 21.5531 26.6815 17.5083 24.0334 14.8602L12.4197 3.24592C9.77096 0.596532 5.72491 0.347875 3.38353 2.68992C1.04275 5.03133 1.29202 9.0761 3.94015 11.7249L7.8341 15.6188",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.6597,
    y1: 14.204,
    x2: 16.8118,
    y2: 9.0518,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPills);
export default __webpack_public_path__ + "static/media/pills.8142c8271f7c91142cb00bc1d9906812.svg";
export { ForwardRef as ReactComponent };